import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PricingProfileAction } from '../pricingProfile.action';
import { PricingProfileTranslator } from '../pricingProfile.translator';

type IDependencies = IClientApiDependencySegment;

export const updatePricingProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PricingProfileAction.update.started),
  mergeMap((params) => {
    const { reject } = params;

    return dependencies.api.updatePricingProfile(PricingProfileTranslator.toApi(params)).pipe(
      mergeMap(() => {
        return [
          PricingProfileAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          PricingProfileAction.update.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
